export const fontStyleName = (family: { name: string }, font: { name: null | string; weight: string }) =>
    font.name || `${family.name} ${font.weight}`;
